import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const MyHelmet = () => {
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <Helmet>
      <html lang={currentLanguage.slice(0, 2)} />
      <title>{t('HELMET.NOT_FOUND.TITLE')}</title>
      <meta name="description" content={t('HELMET.NOT_FOUND.DESCRIPTION')} />
      <link rel="canonical" href="https://www.slex.tv/" />
      {/* Twitter */}
      <meta name="twitter:title" content={t('HELMET.NOT_FOUND.TITLE')} />
      <meta
        name="twitter:description"
        content={t('HELMET.NOT_FOUND.DESCRIPTION')}
      />
      {/* Open Graph / Facebook */}
      <meta property="og:title" content={t('HELMET.NOT_FOUND.TITLE')} />
      <meta
        property="og:description"
        content={t('HELMET.NOT_FOUND.DESCRIPTION')}
      />
      <meta property="og:url" content="https://www.slex.tv/" />
      {/* Don't index this page */}|
      <meta name="robots" content="noindex" />
      <meta name="googlebot" content="noindex" />
    </Helmet>
  );
};
